import React, {useState} from "react";
import Box from "@mui/material/Box";
import {Button, Typography} from "@mui/material";
import {useSelector} from "react-redux";
import {useApi} from "../../hooks/api-hook";
import {API_SPEC} from "../../spec/apiSpec";
import {useLocation, useParams} from "react-router-dom";
import CollectionTabs from "./CollectionTabs";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {columns} from "./definition";
import TableBody from "@mui/material/TableBody";
import {grouper} from "./collectionUtil";
import {galleryLink} from "../../utils/linkMaker";
import PaginatedComponent from "../hoc/PaginatedComponent";
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import {useKeycloak} from "@react-keycloak/web";
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {useNavigate} from "react-router";

export default function UserCollection() {


    const {keycloak} = useKeycloak();
    const {user} = useParams();
    const {page, items} = useSelector((state) => state.collectionReducer)
    const {isLoading, data, api, initialized} = useApi();
    const {
        page: defaultPage,
        rowsPerPage: defaultRowsPerPage,
        offerTypeTab
    } = useSelector((state) => state.controlsReducer)
    const location = useLocation();
    const compared = location.pathname.startsWith("/user/compared")

    React.useEffect(() => {
        const apiSpec = initialized && compared && !!keycloak.authenticated
            ? API_SPEC.COLLECTION_BY_USER_COMPARED : API_SPEC.COLLECTION_BY_USER;
        const collection_spec = apiSpec({
            page: defaultPage,
            size: defaultRowsPerPage,
            user: user,
            offerTypeTab,
            grouped: false
        })
        api(collection_spec);
    }, [initialized, offerTypeTab, compared, keycloak.authenticated, location]);


    const handleChangePage = (newPage, rowsPerPage) => {
        const card_spec = API_SPEC.COLLECTION_BY_USER({
            page: newPage,
            size: rowsPerPage,
            user: user,
            offerTypeTab,
            grouped: false
        })
        api(card_spec);
    };

    const handleChangeRowsPerPage = (size) => {
        const card_spec = API_SPEC.COLLECTION_BY_USER({page: 0, size: size, user: user, offerTypeTab, grouped: false})
        api(card_spec);
    };

    return (
        <>
            <Box sx={{
                marginTop: 4,
                marginBottom: 4,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <Typography variant="h4">{user}'s collection</Typography>
                <Box>
                    {/* */}

                    {initialized && !!keycloak.authenticated ?
                        <Box>
                            <Button color="warning" sx={{margin: 1}} variant={"contained"} startIcon={<JoinInnerIcon/>}>40
                                cards from my Want</Button>
                            <Button color="success" sx={{margin: 1}} variant={"contained"} startIcon={<JoinInnerIcon/>}>10
                                cards from my Have</Button>
                        </Box>
                        :
                        <Button onClick={() => keycloak.login()} sx={{margin: 1}} variant={"contained"}>Login to see
                            matching cards</Button>
                    }
                </Box>
            </Box>


            <CollectionTabs items={items}
                            page={page}
                            handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            DataComponent={CollectionTable}/>
        </>
    )

}


function CollectionTable({items, page, handleChangePage, handleChangeRowsPerPage, isHave}) {
    const edited = false;
    const [grouped, setGrouped] = useState(false);
    const groupedItems = grouper(items.filter(i => i.offerType === isHave), grouped)?.sort((a, b) => a.items[0].id - b.items[0].id);
    const location = useLocation();
    const {user} = useParams();
    const compared = location.pathname.startsWith("/user/compared")
    const navigate = useNavigate()

    const handleChangeGrouped = () => {
        setGrouped(!grouped)
    }

    const handleChangeCompared = () => {
        if (compared) {
            navigate(`/user/${user}`);
        } else {
            navigate(`/user/compared/${user}`);
        }
    }

    return (
        <>
            <FormGroup sx={{display: 'flex'}}>
                <FormControlLabel control={<Switch
                    checked={grouped}
                    onChange={handleChangeGrouped}
                    inputProps={{'aria-label': 'controlled'}}
                />
                } label="Group the same cards"/>
                <FormControlLabel control={<Switch
                    checked={compared}
                    onChange={handleChangeCompared}
                    inputProps={{'aria-label': 'controlled'}}
                />
                } label={isHave ? 'Show only my want' : 'Show only I have'}/>
            </FormGroup>

            <PaginatedComponent size={groupedItems.length} totalElements={page.totalElements}
                                handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage}>
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">{columns.product.headerName}</TableCell>
                                <TableCell align="left">{columns.set.headerName}</TableCell>
                                <TableCell align="left">{columns.type.headerName}</TableCell>
                                <TableCell align="center">{columns.condition.headerName}</TableCell>
                                <TableCell align="center">{columns.language.headerName}</TableCell>
                                <TableCell align="center">{columns.foil.headerName}</TableCell>
                                <TableCell align="left">{columns.rarity.headerName}</TableCell>
                                <TableCell align="right">{columns.quantity.headerName}</TableCell>
                                <TableCell align="right">{columns.price.headerName}</TableCell>
                                <TableCell align="right">{columns.notes.headerName}</TableCell>
                                {/* <TableCell align="right">Action</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {groupedItems.map(({items, count}) => {
                                const row = items[0]
                                return (
                                    <TableRow
                                        key={row.id}
                                        sx={{
                                            '&:last-child td, &:last-child th': {border: 0},
                                            background: edited?.id === row.id ? '#e9e9e9' : 'white'
                                        }}
                                    >
                                        <TableCell align="left">
                                            {row.id > 100
                                                ? columns.product.component(row.cardName, row.setCode, row.collectorNumber, galleryLink(row.object, row.cardId))
                                                : columns.sealed_product.component(row.cardName, row.cardId, row.setCode, row.collectorNumber, galleryLink(row.object, row.cardId))
                                            }</TableCell>
                                        <TableCell align="left">
                                            {columns.set.component(row.setCode)}
                                        </TableCell>
                                        <TableCell align="left">{columns.type.component(row.typeLine)}</TableCell>
                                        <TableCell
                                            align="center">{columns.condition.component(row.condition, false)}</TableCell>
                                        <TableCell
                                            align="center">{columns.language.component(row.language, false)}</TableCell>
                                        <TableCell align="center">{columns.foil.component(row.foil, false)}</TableCell>
                                        <TableCell align="left">{columns.rarity.component(row.rarity)}</TableCell>
                                        <TableCell align="right">{columns.quantity.component(count)}</TableCell>
                                        <TableCell
                                            align="right">{columns.price.component(row.price / 100, false)}</TableCell>
                                        <TableCell
                                            align="right">{columns.notes.component(row.notes, false)}</TableCell>
                                        {/* <TableCell align="right">
                                            <BuyEasyCart id={row.cardId} offerType={isHave ? 'Buy' : 'Sell'} objectType={'sealed'}/>
                                        </TableCell> */}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </PaginatedComponent>
        </>
    )
}

